<template>
    <div>
         <action-row>
            <my-btn type="new" @click="addHandler()"></my-btn>
         </action-row>
        <my-table :data="tableData" >      
            <!-- <el-table-column label="问题编码" prop="wtcode"></el-table-column> -->
            <el-table-column label="标段名称" prop="bdname" sortable></el-table-column>
            <el-table-column label="提交单位名称" prop="tjdwname" sortable></el-table-column>
            <el-table-column label="问题标题" prop="yqcqwttitle" sortable></el-table-column>
            <el-table-column label="问题内容" prop="yqcqwt" sortable>
                  <template slot-scope="scope">
                     <div v-html="scope.row.yqcqwt"></div>
                </template>   
            </el-table-column>
            <el-table-column label="问题提交时间" prop="yqtjtime" sortable></el-table-column>
            <el-table-column label="状态" width="180">
                <template slot-scope="scope">
                     <template v-if="scope.row.exthfbj === null || scope.row.exthfbj ==='0'">
                        <my-tag type="primary" v-if="scope.row.shbj==='0'">
                            已提交，待审核
                        </my-tag>
                        <my-tag type="warning" v-if="scope.row.shbj==='1'">
                            待回复
                        </my-tag>
                        <my-tag type="danger" v-if="scope.row.shbj==='3'">
                            已退回，原因：{{scope.row.by1}}
                        </my-tag>
                    </template>
                    <template v-else>
                        <my-tag type="success">
                            已回复
                        </my-tag>
                    </template>
                </template>         
            </el-table-column>
            <el-table-column label="回复内容" prop="exthfcontent" sortable>
                <template slot-scope="scope">
                     <div v-html="scope.row.exthfcontent"></div>
                </template>  
            </el-table-column>
            <el-table-column label="回复时间" prop="modifydate" sortable></el-table-column>
            <el-table-column label="操作" sortable>
                <template slot-scope="scope">
                    <my-btn
                        type="detail"
                        @click="seeFujian(scope.row.fileguid)">
                        查看附件
                    </my-btn>
                    <!-- <template v-if="scope.row.shbj === '3'">
                        <el-button type="edit" @click="editHandler(scope.row.wtcode)">修改</el-button> 
                    </template> -->
                </template>
            </el-table-column>
            <el-table-column label="详细信息" sortable>
                <template slot-scope="scope">
                     <template v-if="scope.row.exthfbj === null || scope.row.exthfbj ==='0'">
                        <my-btn
                        type="detail"
                        @click="hfdetail(scope.row.wtcode)" v-if="scope.row.shbj === '1'">
                        详情
                        </my-btn>
                        <my-btn
                        type="del"
                        @click="del(scope.row.wtcode)" v-else>
                        删除
                        </my-btn>
                    </template>
                    <template v-else>
                        <my-btn
                        type="detail"
                        @click="hfdetail(scope.row.wtcode)">
                        详情
                        </my-btn>
                    </template>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('bidUrl')}/pingbiao/zgscCqwt/get_list.json`">
        </my-pagination>

        <my-dialog v-model="dialogVisible" width="1200px">
            <component
                v-if="dialogVisible"
                :is="dialogComponent"
                :data="dialogData"
                @cancle="dialogClose"
            ></component>
        </my-dialog>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'

export default {
    mixins: [ FORM_PAGE_MIXIN, LIST_PAGE_MIXIN, DIALOG_LIST_PAGE_MIXIN ],
    components: {
        FormCqwt: () => import('./cqwt-form'),
        fujian: () => import('./fujian'),
        detail: () => import('./detail'),
    },
    data() {
        return {
            pgData: {
                bdid:this.getQuery('bdcode'),
                sortname: 'wtcode',  
            },
            dialogComponent: '',
            dialogData: {}
        }
    },
    computed: {
        query() {                                    
            return this.getQuery()
        }
    },
    methods: {
        // editHandler(wtcode) {
        //     this.dialogData = {
        //         id: wtcode
        //     };
        //     this.dialogComponent = 'form-edit';
        //     this.dialogShow();
        // },
        addHandler(){
            this.dialogData = {
                bdcode:this.getQuery('bdcode')
            };
            this.dialogComponent = 'form-cqwt';
            this.dialogShow();
        },
        seeFujian(fileguid) {
            this.dialogData = {
                fileguid:fileguid
            };
            this.dialogComponent = 'fujian';
            this.dialogShow();
        },
        hfdetail(wtcode) {
            this.dialogData = {
                wtcode:wtcode
            };
            this.dialogComponent = 'detail';
            this.dialogShow();
        },
        del(wtcode) {
            this.$post(`${this.getGetters('mngUrl')}/Zbzz/ZbYcZz/del.json`,{wtcode:wtcode}, (data, res) => {
                ShowMsg('删除成功', 'success')
                that.reload()
            }); 
        },  
        
    },     
    created() {
        this.jspInit(`${this.getGetters('bidUrl')}/pingbiao/zgscCqwt/dbdlist.json`, 
        {
           bdcode:this.getQuery('bdcode'),
        }
        ,data => {

         
        });
    }
}
</script>

<style scoped lang="scss">

</style>
